import { api } from "@/lib/api";
import type { Project } from "@/types/admin";

export interface ProjectsListResponse {
	data: Project[];
	meta: {
		page: number;
		limit: number;
		total: number;
		totalPages: number;
		hasNext: boolean;
		hasPrev: boolean;
	};
}

export interface ProjectsFilters {
	page?: number;
	limit?: number;
	userId?: string;
	search?: string;
}

// Projects API Service
export const projectsService = {
	// Get paginated list of projects
	getProjects: async (
		page = 1,
		limit = 50,
		filters?: Omit<ProjectsFilters, "page" | "limit">,
	): Promise<ProjectsListResponse> => {
		const params = {
			page,
			limit,
			...filters,
		};

		const response = await api.get<ProjectsListResponse>(
			"/admin/projects",
			params,
		);
		if (!response.data.success || !response.data.data) {
			throw new Error("Failed to fetch projects");
		}
		return response.data.data;
	},

	// Get project by ID
	getProject: async (projectId: string): Promise<Project> => {
		const response = await api.get<Project>(`/admin/projects/${projectId}`);
		if (!response.data.success || !response.data.data) {
			throw new Error("Failed to fetch project");
		}
		return response.data.data as Project;
	},
};
